import type { SupportedLanguage } from '@/lib/user-language'

const LABELS: Record<string, { en: string; es: string }> = {
  Quality: { en: 'Quality', es: 'Calidad' },
  Operations: { en: 'Operations', es: 'Operaciones' },
  Engineering: { en: 'Engineering', es: 'Ingenieria' },
  'Regulatory Affairs': { en: 'Regulatory Affairs', es: 'Asuntos regulatorios' },
  Manufacturing: { en: 'Manufacturing', es: 'Manufactura' },
  Validation: { en: 'Validation', es: 'Validacion' },
  Equipment: { en: 'Equipment', es: 'Equipo' },
  Compliance: { en: 'Compliance', es: 'Cumplimiento' },
  Deviation: { en: 'Deviation', es: 'Desviacion' },
  CAPA: { en: 'CAPA', es: 'CAPA' },
  Other: { en: 'Other', es: 'Otro' },
  Sealing: { en: 'Sealing', es: 'Sellado' },
  Testing: { en: 'Testing', es: 'Pruebas' },
  Assembly: { en: 'Assembly', es: 'Ensamble' },
  Packaging: { en: 'Packaging', es: 'Empaque' },
  Labelling: { en: 'Labelling', es: 'Etiquetado' },
  Sterilisation: { en: 'Sterilisation', es: 'Esterilizacion' },
  'Guidance on next steps': { en: 'Guidance on next steps', es: 'Orientacion sobre proximos pasos' },
  'Approval of proposed strategy': { en: 'Approval of proposed strategy', es: 'Aprobacion de estrategia propuesta' },
  'Review of documentation': { en: 'Review of documentation', es: 'Revision de documentacion' },
  'Regulatory interpretation': { en: 'Regulatory interpretation', es: 'Interpretacion regulatoria' },
  critical: { en: 'Critical', es: 'Critica' },
  high: { en: 'High', es: 'Alta' },
  medium: { en: 'Medium', es: 'Media' },
  low: { en: 'Low', es: 'Baja' },
  Critical: { en: 'Critical', es: 'Critica' },
  High: { en: 'High', es: 'Alta' },
  Medium: { en: 'Medium', es: 'Media' },
  Low: { en: 'Low', es: 'Baja' },
  Major: { en: 'Major', es: 'Mayor' },
  Minor: { en: 'Minor', es: 'Menor' },
  Observation: { en: 'Observation', es: 'Observacion' },
  'Process gap': { en: 'Process gap', es: 'Brecha de proceso' },
  'Knowledge gap': { en: 'Knowledge gap', es: 'Brecha de conocimiento' },
}

export function getConfigOptionLabel(value: string | null | undefined, language: SupportedLanguage): string {
  if (!value) return ''
  return LABELS[value]?.[language] ?? value
}
